import { render } from "./Traz.vue?vue&type=template&id=4954e612&scoped=true"
import script from "./Traz.vue?vue&type=script&lang=js"
export * from "./Traz.vue?vue&type=script&lang=js"

import "./Traz.vue?vue&type=style&index=0&id=4954e612&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4954e612"]])

export default __exports__